module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/axios/index.js
// module id = 29
// module chunks = 0